import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Header from '../component/Header';
import Footer from '../component/Footer';
import CheckIcon from '../assets/images/subscription/right.svg';

const featureLabels = [
  'Number of Property Listings',
  'Property Photos',
  'Property Description & Amenities',
  'Agent Profile Page',
  'Property Search Visibility',
  'Featured Property Placement',
  'Property Video Upload',
  'Virtual Tour / 360° View',
  'Lead Management Dashboard',
  'Social Media Promotion',
  'Priority Search Ranking',
];

const plans = [
  {
    id: 'free',
    name: 'Free',
    price: 0,
    buttonStyle: 'style-3',
    features: ['5', 'Up to 5 per listing', true, true, false, false, false, false, false, false, false],
  },
  {
    id: 'professional',
    name: 'Professional',
    price: 25,
    popular: true,
    buttonStyle: '',
    features: ['25', 'Up to 15 per listing', true, true, true, true, true, false, false, false, false],
  },
  {
    id: 'enterprise',
    name: 'Enterprise',
    price: 49,
    buttonStyle: 'style-3',
    features: ['Unlimited', 'Unlimited', true, true, true, true, true, true, true, true, true],
  },
];

const Subscription = () => {
  const navigate = useNavigate();

  const handleChoosePlan = (plan) => {
    navigate('/subscription-checkout', { state: { planId: plan.id, planName: plan.name, price: plan.price } });
  };

  return (
    <div className="main subscription-page full-header">
      <Header />
      <section className="subscription-section common-padding">
        <Container>
          <div className="subscription-table-wrap">
            <table className="subscription-table">
              <thead>
                <tr>
                  <th className="feature-col"> 
                    <div>
                      <h2>Compare plans</h2>
                      <p>Choose your workspace plan according to your organisational plan</p>
                    </div>
                  </th>
                  {plans.map((plan) => (
                    <th key={plan.id} className={plan.popular ? 'popular' : ''}>
                      <div className="plan-name">{plan.name}</div>
                      <div className="plan-price">
                        <span className="amount">${plan.price}</span>
                        <span className="period">/Month</span>
                      </div>
                      <Button
                        className={`custom-bttn ${plan.buttonStyle}`}
                        onClick={() => handleChoosePlan(plan)}
                      >
                        Get Started
                      </Button>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {featureLabels.map((label, rowIndex) => (
                  <tr key={label}>
                    <td className="feature-col">{label}</td>
                    {plans.map((plan) => {
                      const value = plan.features[rowIndex];
                      return (
                        <td key={plan.id} className={plan.popular ? 'popular' : ''}>
                          {typeof value === 'string' ? (
                            value
                          ) : value ? (
                            <span className="check-icon">
                              <img src={CheckIcon} alt="Included" />
                            </span>
                          ) : (
                            <span className="dash"></span>
                          )}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Container>
      </section>
      <Footer />
    </div>
  );
};

export default Subscription;
